module.exports = __webpack_public_path__ + "img/contectBg.74376171.jpg";